import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import Swiper from "swiper";
import "swiper/css/swiper.css";
let _ = require("lodash");
import { mapState, mapGetters, mapMutations } from "vuex";
import { getImg, formatRGBA } from "@/utils/utils";
export default {
  name: "routelist",
  emits: ["route", "routelistflag"],
  props: {
    typelist: {
      type: Array,
      default: []
    },
    routelist: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    },
    style: {
      type: Object,
      default: {}
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tIndex: 0,
      dataList: [],
      rIndex: "",
      showlistflag: false,
      lock: false,
      pointData: []
    };
  },
  computed: {
    ...mapGetters(["mapv2info"])
  },
  watch: {
    typelist: {
      handler(val) {
        if (val.length > 0) {
          this.$nextTick(() => {
            this.swiperEl = new Swiper(this.$refs.swipercontainer, {
              initialSlide: 0,
              slidesPerView: "auto",
              observeSlideChildren: true,
              observeParents: true,
              observer: true,
              navigation: {
                nextEl: this.$refs.swiperbuttonnext,
                prevEl: this.$refs.swiperbuttonprev
              }
            });
          });
        }
      },
      deep: true
    },
    routelist: {
      handler(val) {
        if (this.typelist.length > 0) {
          this.dataList = val.filter(item => {
            return item.itemformdata.typeId === this.typelist[0].itemformdata.onlyid;
          });
        }
      },
      deep: true
    },
    pointlist: {
      handler(val) {
        this.pointData = val;
      },
      deep: true
    },
    "style.routepopcolor": {
      handler(val) {
        if (val) this.setAgba(val);
      },
      deep: true
    },
    "mapv2info.style.routepopcolor": {
      handler(val) {
        if (val) this.setAgba(val);
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    typeClick(item, i) {
      this.tIndex = i;
      this.rIndex = "";
      this.dataList = this.routelist.filter(elem => {
        return elem.itemformdata.typeId === item.itemformdata.onlyid;
      });
      // this.$emit('route', this.dataList)
    },
    getPoint(json) {
      let data = {
        ...JSON.parse(json.replace(/(<\/?p.*?>)/gi, ""))
      };
      return data.routedata.map(elem => {
        return this.pointData.find(point => {
          return point.id === elem.id;
        });
      });
    },
    routeClick(item) {
      this.rIndex = this.rIndex === item.id ? "" : item.id;
      this.$emit("route", this.rIndex !== "" ? [item] : []);
      // if (this.isMobile) this.showlistflag = false
    },
    getrouteBtnstyle(val) {
      let pos = val.routepos !== undefined ? {
        ...val.routepos
      } : {
        ...this.mapv2info.style.routepos
      };
      let other = val.routebtn !== undefined ? {
        ...val.routebtn
      } : {
        ...this.mapv2info.style.routebtn
      };
      if (Object.keys(pos).length > 0 && Object.keys(other).length > 0) {
        let data = {
          ...other[0]
        };
        if (data.imgList && data.imgList.length > 0) {
          data.backgroundImage = "url('" + getImg(data.imgList[0]) + "')";
          data.backgroundSize = "100% 100%";
          data.backgroundRepeat = "no-repeat";
        }
        data.textAlign = "center";
        delete data.imgList;
        let formatData = Object.assign({}, pos, data);
        Object.keys(formatData).forEach(child => {
          if (this.isMobile) {
            formatData[child] = /px$/.test(formatData[child]) ? `${parseFloat((parseInt(formatData[child]) / 2 / 37.5).toFixed(6))}rem` : formatData[child];
          } else {
            formatData[child] = /px$/.test(formatData[child]) ? `${parseFloat((parseInt(formatData[child]) / 1920 * 100).toFixed(6))}vw` : formatData[child];
          }
        });
        return formatData;
      }
    },
    routebtnHide() {
      this.showlistflag = false;
      this.rIndex = "";
      this.typeClick(this.typelist[0], 0);
    },
    routebtnHandle() {
      this.showlistflag = true;
    },
    closeroutelist() {
      this.$emit("route", []);
    },
    setAgba(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.5)`;
      document.documentElement.style.setProperty("--hand-drawn-routepop-colortheme1", theme1);
      document.documentElement.style.setProperty("--hand-drawn-routepop-colortheme05", theme2);
    }
  }
};